import React from 'react';
import styles from './SectionDivider.module.css';

// variant: 'cream-to-blue' | 'blue-to-cream' | 'blue-to-dark'
const SectionDivider = ({ variant = 'cream-to-blue' }) => {
  const colorMap = {
    'cream-to-blue': { top: '#F0EDE8', bottom: '#3B46D0' },
    'blue-to-cream': { top: '#3B46D0', bottom: '#F0EDE8' },
    'blue-to-dark': { top: '#3B46D0', bottom: '#1A1A1A' },
  };

  const { top: topColor, bottom: bottomColor } = colorMap[variant] || colorMap['cream-to-blue'];

  return (
    <div className={styles.divider} style={{ background: bottomColor }}>
      <svg
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
        className={styles.svg}
        fill={topColor}
      >
        <path d="M0,0 L0,45 Q30,52 60,44 Q90,36 120,42 Q150,48 180,40 Q210,32 240,38 Q270,44 300,36 Q330,28 360,35 Q390,42 420,38 Q450,34 480,40 Q510,46 540,42 Q570,38 600,44 Q630,50 660,46 Q690,42 720,48 Q750,54 780,48 Q810,42 840,46 Q870,50 900,44 Q930,38 960,42 Q990,46 1020,40 Q1050,34 1080,38 Q1110,42 1140,36 Q1170,30 1200,36 Q1230,42 1260,38 Q1290,34 1320,40 Q1350,46 1380,42 Q1410,38 1440,44 L1440,0 Z" />
      </svg>
    </div>
  );
};

export default SectionDivider;
